import { FunctionalComponent, h } from '@stencil/core';
import { RudyPictureCustomEvent } from '../../../../components';

export const enum PictureFadeDirection {
  NONE = '',
  LEFT = 'fadein-left',
  RIGHT = 'fadein-right',
  BOTTOM = 'fadein-bottom',
  TOP = 'fadein-top',
}

export const enum RevealType {
  NONE = '',
  HEADER = 'header',
}

export interface PictureProps {
  sources: {
    xl?: string;
    l?: string;
    m?: string;
    s?: string;
  };
  caption?: string;
  fitContainer?: boolean;
  alt?: string;
  title?: string;
  overlay?: boolean;
  reveal?: Boolean;
  revealType?: RevealType;
  aspectRatio?: string;
  sharedElement?: Boolean;
  scrollTrigger?: Boolean;
  onLoaded?: ((event: RudyPictureCustomEvent<any>) => void) & ((event: Event) => void);
}

export const Picture: FunctionalComponent<PictureProps> = ({
  sources,
  fitContainer,
  alt,
  caption,
  title,
  overlay,
  reveal,
  aspectRatio,
  sharedElement,
  scrollTrigger,
  revealType,
  onLoaded,
}) => {
  return (
    <rudy-picture
      onLoaded={onLoaded}
      sources={sources}
      fitContainer={fitContainer}
      alt={alt}
      caption={caption}
      title={title}
      overlay={overlay}
      reveal={reveal}
      aspectRatio={aspectRatio}
      sharedElement={sharedElement}
      scrollTrigger={scrollTrigger}
      revealType={revealType}
    />
  );
};
